// store/modules/skills.js
import api from '@/api/api';

export default {
    namespaced: true,
    state: {
        list: []
    },
    getters: {
        all: state => state.list
    },
    mutations: {
        SET_SKILLS(state, skills) {
            state.list = skills;
        }
    },
    actions: {
        async fetchSkills({ commit }, { search, limit = 10 }) {
            const res = await api.get('/recommended-skills', { params: { search, limit }});
            commit('SET_SKILLS', res.data.data.map(s => s.name));
            return res.data.data;
        }
    }
};
